
fx.ns("shared.stage", class Area extends fx.Component {
    
    constructor(data, model, parentContainer, side, preview)
    {
        super(data);

        this._model = model;
        this._creation = model.creation;
        this._parentContainer = parentContainer;
        this._actionsEnabled = true;
        this._dragActive = false;
        this._rawDisplay = false;

        this.displayedSide = side;
        this.preview = preview;
        
        this.listenUpdates(this._model, true);
    }

    /***************** Getters / Setters *****************/

    get rawDisplay()
    {
        return this._rawDisplay;
    }

    set rawDisplay(val)
    {
        this._rawDisplay = val;
    }

    // displayed part of BookArea. Used to display front cover / back cover only.
    get displayedSide()
    {
        return this._displayedSide;
    }

    set displayedSide(val)
    {
        if (this._displayedSide)
            this.removeClass( this._displayedSide );

        this._displayedSide = val;

        if (this._displayedSide)
            this.addClass( this._displayedSide );
    }

    get loaded()
    {
        return this.stage && this.stage.loaded;
    }

    /*get loadedFirst()
    {
        return this._loadedFirst;
    }*/

    get single()
    {
        return !!this._displayedSide;
    }


    get scale()
    {
        return this._scale;
    }

    set scale(val)
    {
        this._scale = val;
    }

    get model()
    {
        return this._model;
    }

    set model(val)
    {
        this._model = val;
        this._creation = model.creation;
    }

    get element()
    {
        return this.data;
    }

    set element(val)
    {
        this.data = val;

        if (this.initialized)
            //this.load(this.element, this.displayedSide);
            this.load();
    }

    get creation()
    {
        return this._creation;
    }

    set creation(val)
    {
        this._creation = val;
    }

    get parentContainer()
    {
        return this._parentContainer;
    }

    get active()
    {
        return this._active;
    }

    set active(val)
    {
        this._active = val;

        if (val)
            this.addClass("active");
        else
            this.removeClass("active");
    }

    get pageWidth()
    {
        return this.element.width;
    }

    get pageHeight()
    {
        return this.element.height;
    }

    /***************** Actions *****************/


    onReady()
    {
        super.onReady();
        this.on("component-added", this.onComponentAdded, this.stage);
    }

    create()
    {
        super.create();
            
        this.stageContainer = new fx.components.Box("stage-container");

        this.stage = new shared.stage.Stage(this.element, this.model, this._parentContainer.componentFactory, this.displayedSide, this.preview);
        this.stage = new shared.stage.Stage(this.element, this.model, this._parentContainer.componentFactory, this.displayedSide, this.preview);

        this.stageContainer.addChild(this.stage, {top:0, left:0, height:this.height(), width:this.width()});

        this.addChild(this.stageContainer, {top:0, left:0, height:this.height(), width:this.width()});

        if (this.element)
            this.attr("data-id", this.element.id);
    }

    refresh()
    {
        this.stage.updateScale();
    }

    // disable native positionning
    position() {}

    addComponent(data)
    {
        this.element.addComponent( data, this.creation.pageWidth, this.creation.pageHeight);
    }

    applyBackground(background)
    {
        this.data.applyBackground(background);
    }

    removeAllComponents()
    {
        this.element.removeAllComponents();
        this.element.removeAllComponents();
    }

    load()
    {
        //if (this.loaded) return;

        this.stage.load(this.data, this.displayedSide);
        this.addClass("loaded");
    }

    unload()
    {
        //if (!this.loaded || this.dragActive) return;

        this.stage.unload();
        this.removeClass("loaded");
    }

    getElement(id)
    {
        return this.stage.getChild(id);
    }

    getChildFromData(data)
    {
        return this.stage.getChildFromData(data);
    }

    setBackground(color)
    {
        this.element.updateBackgroundColor( color );
        this.element.updateBackgroundColor( color );
    }

    viewport(val, applyOnly)
    {
        super.viewport(val, applyOnly);

        if (this.stage)
        {
            this.stageContainer.viewport(val, applyOnly);
            this.stage.viewport(val, applyOnly);
        }
    }

    applyLayout(layout, side)
    {
        this._applyLayout(layout, false, side);
    }


    applyLayoutAll(layout)
    {
        this._applyLayout(layout, true);
    }

    _applyLayout(layout, all, side)
    {
        if (!this.model) return;
        
        if (all || side)
            this.activeSide = side ? side : "";

        let mediasToLoad = this._getMediasToLoad(layout);
        
        if ( mediasToLoad.length == 0)
        {
            let pageWidth = layout.doublepage ? this.pageWidth : this.creation.pageWidth;
            let pageHeight = this.pageHeight;

            if (all)
                this.creation.applyLayout( layout);
            else
                this.element.applyLayout( layout, pageWidth, pageHeight, this.extraWidth, this.activeSide);
        }
            
        else
        {
            this._layoutToApply = {all : all, layout : layout, side : this.activeSide};
            this.model.loadLayoutMedias( mediasToLoad );
            this.loading(true, fx.text("Chargement"), "light");
        }
    }

    addPhoto(data)
    {
        if (data.side)
            this.activeSide = data.side;
        
        // if activeSide is empty
        if (this.activeSide == "")
        {
            // check if empty photos on double page from the left to the right
            let components = this.data.photosComponents.sort( (a, b) => a.x - b.x );
            for(let i = 0; i < components.length; i++)
            {
                let component = components.getItemAt(i);
                if (component.content == "")
                {
                    component.content = data.content;
                    return;
                }
            }
            // otherwise, set activeSide to empty : which mean it will fill first page and then second one
            this.activeSide = "";
        }
        
        let activeSide = (this.activeSide == "") ? "left" : this.activeSide;
        
        let components = this.data.photosComponents.filter(a => ( activeSide == "left") ? 
                                                                        (fx.graphics.getBoundingRect(a, a.rotation).x < this._creation.pageWidth) : 
                                                                        (fx.graphics.getBoundingRect(a, a.rotation).x >= this._creation.pageWidth + this.extraWidth) );

        if(components.length >= fx.get("settings").numMaxPhoto && this.activeSide == "")
        {
            activeSide = "right";
            
            components = this.data.photosComponents.filter(a => ( activeSide == "left") ? 
                                                                        (fx.graphics.getBoundingRect(a, a.rotation).x < this._creation.pageWidth) : 
                                                                        (fx.graphics.getBoundingRect(a, a.rotation).x >= this._creation.pageWidth + this.extraWidth) );
        }
            
        
        components.sort( (a, b) => a.x - b.x );

        // first find if a photo component is empty, and use it
        // otherwise find layout with enougth pics
        for(let i = 0; i < components.length; i++)
        {
            let component = components.getItemAt(i);
            if (component.content == "")
            {
                component.content = data.content;
                return;
            }
        }

        // if already max pics
        if (components.length >= fx.get("settings").numMaxPhoto)
        {
            // so we update biggest picture
            components.sort( (a, b) => (b.width * b.height) - (a.width * a.height) );
            components.getItemAt(0).content = data.content;
            return;
        }
            
        let photos = [];
        for(let i = 0; i < components.length; i++)
        {
            let component = components.getItemAt(i);
            let photo = this.model.photos.find({id : component.content})
            if (photo)
                photos.push( photo )
        }

        let photo = this.model.photos.find({id : data.content});
        if (photo)
            photos.push( photo )

        let layouts = fx.service("LayoutsGenerator").getLayouts(photos);

        if (layouts.length == 0) return;
        
        this.initLayoutData();

        let pageWidth = this._creation.pageWidth;
        this.data.addPhoto( photos, pageWidth, this.pageHeight, layouts[0] );
    }

    initLayoutData()
    {
        this._layoutData = {    
                                left : { code : "", position : 0} , 
                                right : { code : "", position : 0} 
                            };

    }

    _getMediasToLoad(layout)
    {
        // check all stickers and backgrounds
        // and load them if not existing
        let stickers = layout.getStickers();
        let backgrounds = layout.getBackgrounds();

        let mediasToLoad = [];

        for (let i = 0; i < stickers.length; i++)
        {
            if ( stickers[i].content && !this.model.stickers.find({id : stickers[i].content}) )
                mediasToLoad.push( {type : "sticker", id : stickers[i].content });
        }

        for (let i = 0; i < backgrounds.length; i++)
        {
            if ( backgrounds[i].content && !this.model.backgrounds.find({id : backgrounds[i].content}) )
                mediasToLoad.push( {type : "background", id : backgrounds[i].content });
        }

        return mediasToLoad;
    }

    _layoutMediasLoaded()
    {
        if (this._layoutToApply)
        {
            this.loading(false);

            if (this._layoutToApply.all)
                this.creation.applyLayout(this._layoutToApply.layout);
            else
                this.element.applyLayout( this._layoutToApply.layout,  this.pageWidth, this.pageHeight, this.extraWidth, this._layoutToApply.side);
                

            this._layoutToApply = null;
        }
    }

    /***************** Events *****************/

    // When a Text is added manually, we need to display Frame and ToolBar
    onComponentAdded(event)
    {
        if (!event.detail.component)
        return;
        
        if (event.detail.component.data.isText && (event.detail.component.data.creation == "manual" || event.detail.component.data.creation == "dropped"))
            this.trigger("select", {area : this, element : event.detail.component});

        this.updateCode();
    }

    onDataUpdated(action)
    {
        super.onDataUpdated(action);

        if (action.impacts("id") && action.model instanceof models.Creation)
            this.attr("data-id", this.element.id);
            this.attr("data-id", this.element.id);
        
        this.updateCode();
    }

    onChildUpdated(action)
    {
        if (action.model instanceof models.CreationElementContent)
            this.updateCode(); 
    }

    onDataEvent(event)
    {
        super.onDataEvent(event);

        switch (event.type) 
        {
            case "fonts-loaded" :
                this.updateCode();
                event.stopPropagation();
                break;
                
            case "media-loaded" :
                this.updateCode();
                break;

            case "layout-medias-loaded":
                this._layoutMediasLoaded();
            break;

            case "load-layout-medias-error" :
                this.loading(false);
            break;
        }

    }

    onDisplayUpdated()
    {
        super.onDisplayUpdated();

        if (this.stage)
            this.stage.scale = this.scale;
    }


    updateCode()
    {
        if (fx.get("app") != "config")
            return;

        // everytime a page is updated, we update SVG
        this.delay(this._updateCode, 250);
    }

    _updateCode()
    {
        if (this.data && this.stage.loaded)
            this.data.prop("code", (this.displayedSide == "right" && this.data.isCover ? "<style>.Stage { left : 0px!important;}</style>" : "") + this.stage.contentHTML);
    }

    selectActivePart()
    {
        if (!this.stage || !this.stage.node) return;
        
        this.active = true;
    }
   

});